// import axios from 'axios';
// import constants from '../constants';
// import authService from '../auth/AuthService';
import moment from "moment";
import AppUsersClient from "../clients/AppUsersClient";

const resource = "/report";

export default {
  // Get's data for a given period and group. Group is mandatory. Data is grouped by type and user
  getReportForPeriod(startDate, endDate, forGroup) {
    return new Promise(function(resolve, reject) {
      AppUsersClient.get(
        `${resource}/getReportForPeriod/?fromdate=${moment(startDate).format(
          "YYYY-MM-DD"
        )}&todate=${moment(endDate).format("YYYY-MM-DD")}&forGroup=${
          forGroup ? forGroup : ""
        }`
      )
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  // Get's data for a given period and region. Region is mandatory. Data is grouped by type
  getReplacementReportForPeriod(startDate, endDate, forRegion) {
    return new Promise(function(resolve, reject) {
      AppUsersClient.get(
        `${resource}/getReplacementReportForPeriod/?fromdate=${moment(
          startDate
        ).format("YYYY-MM-DD")}&todate=${moment(endDate).format(
          "YYYY-MM-DD"
        )}&forRegion=${forRegion ? forRegion : ""}`
      )
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  // Get's data for a given period and region. Region is mandatory. Data is grouped by type
  getGeneralReportForPeriod(startDate, endDate, forGroup, forRegion) {
    return new Promise(function(resolve, reject) {
      AppUsersClient.get(
        `${resource}/getGeneralReportForPeriod/?fromdate=${moment(
          startDate
        ).format("YYYY-MM-DD")}&todate=${moment(endDate).format(
          "YYYY-MM-DD"
        )}&forGroup=${forGroup ? forGroup : ""}&forRegion=${
          forRegion ? forRegion : ""
        }`
      )
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  // Get's monthly data for a given period and group\user. Group\User is mandatory. Data is grouped by month
  getAbsenceStatisticsForPeriod(startDate, endDate, forGroup, forUser) {
    return new Promise(function(resolve, reject) {
      AppUsersClient.get(
        `${resource}/getAbsenceStatisticsForPeriod/?fromdate=${moment(
          startDate
        ).format("YYYY-MM-DD")}&todate=${moment(endDate).format(
          "YYYY-MM-DD"
        )}&forGroup=${forGroup ? forGroup : ""}&forUser=${
          forUser ? forUser : ""
        }`
      )
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  // Get's monthly data for a given period and group\user. Group\User is mandatory. Data is grouped by month
  getDriveReportForPeriod(startDate, endDate, forGroup) {
    return new Promise(function(resolve, reject) {
      AppUsersClient.get(
        `${resource}/getDriveReportForPeriod/?fromdate=${moment(
          startDate
        ).format("YYYY-MM-DD")}&todate=${moment(endDate).format(
          "YYYY-MM-DD"
        )}&forGroup=${forGroup ? forGroup : ""}`
      )
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  // Get's monthly data for a given period and group\user. Group\User is mandatory. Data is grouped by month
  getTimeOffForPeriod(startDate, endDate, forGroup) {
    return new Promise(function(resolve, reject) {
      AppUsersClient.get(
        `${resource}/getTimeOffForPeriod/?fromdate=${moment(startDate).format(
          "YYYY-MM-DD"
        )}&todate=${moment(endDate).format("YYYY-MM-DD")}&forGroup=${
          forGroup ? forGroup : ""
        }`
      )
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  // Get's monthly report for a given year and user. User is mandatory. Data is grouped by day
  getMonthReport(year, month, forUser) {
    return new Promise(function(resolve, reject) {
      AppUsersClient.get(
        `${resource}/getMonthReport/?year=${year}&month=${month}&forUser=${
          forUser ? forUser : ""
        }`
      )
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  approveAllMonthReport(year, month, forUser) {
    return new Promise(function(resolve, reject) {
      AppUsersClient.post(`${resource}/approveAllMonthReport`, {
        year: year,
        month: month,
        forUser: forUser,
      })
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  approveMonthReport(date, forUser) {
    return new Promise(function(resolve, reject) {
      AppUsersClient.post(`${resource}/approveMonthReport`, {
        date: moment(date).format("YYYY-MM-DD"),
        forUser: forUser,
      })
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  // Get's monthly report for a given year and group. Group is mandatory. Data is grouped by day
  getMonthGroupReport(year, month, forGroup, forRegion) {
    return new Promise(function(resolve, reject) {
      AppUsersClient.get(
        `${resource}/getMonthGroupReport/?year=${year}&month=${month}&forGroup=${
          forGroup ? forGroup : ""
        }&forRegion=${forRegion ? forRegion : ""}`
      )
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  getYearlyReport(year, forUser) {
    return new Promise(function(resolve, reject) {
      AppUsersClient.get(
        `${resource}/getYearlyReport/?year=${year}&forUser=${
          forUser ? forUser : ""
        }`
      )
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  getReportNotification(employeeId) {
    let requestUrl = employeeId
      ? `${resource}/getReportNotification?employeeId=${employeeId}`
      : `${resource}/getReportNotification`;

    return new Promise(function(resolve, reject) {
      AppUsersClient.get(requestUrl)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  getDTReport(employeeId, year, month) {
    let requestUrl = `${resource}/getDtReport?assistantNumber=${employeeId}&year=${year}&month=${month}`;
    return new Promise(function(resolve, reject) {
      AppUsersClient.get(requestUrl)
        .then((response) => {
          console.log(response.data);
          resolve(response.data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  updateDTReport(data) {
    let requestUrl = `${resource}/updateDtReport`;
    return new Promise(function(resolve, reject) {
      AppUsersClient.put(requestUrl, data)
        .then((response) => {
          resolve(response.data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  deleteDTReport(id){
    let requestUrl = `${resource}/deleteDtReport/${id}`;
    return new Promise(function(resolve, reject) {
      AppUsersClient.delete(requestUrl)
        .then((response) => {
          resolve(response.data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  getSalaryReport(employeeId, fromDate, toDate, compareDate, userDefined) {
    let requestUrl = `${resource}/getSalaryReport?assistantNumber=${employeeId}&fromDate=${fromDate.toJSON()}&toDate=${toDate.toJSON()}&compareDate=${compareDate}&userDefined=${userDefined}`;

    return new Promise( function ( resolve, reject ) {
      AppUsersClient.get( requestUrl )
        .then( ( response ) => {
          resolve( response.data );
        } )
        .catch( ( error ) => {
          reject( error );
        } );
    } );
  },
  getTotalSalaryReport(fromDate, toDate, compareDate, userDefined) {
    let requestUrl = `${resource}/getTotalSalaryReport?fromDate=${fromDate.toJSON()}&toDate=${toDate.toJSON()}&compareDate=${compareDate}&userDefined=${userDefined}`;

    return new Promise( function ( resolve, reject ) {
      AppUsersClient.get( requestUrl )
        .then( ( response ) => {
          resolve( response.data );
        } )
        .catch( ( error ) => {
          reject( error );
        } );
    } );
  },
  getSalaryDayReport(employeeId, fromDate) {
    let requestUrl = `${resource}/getSalaryDayReport?assistantNumber=${employeeId}&fromDate=${fromDate.toJSON()}`;

    return new Promise(function(resolve, reject) {
      AppUsersClient.get(requestUrl)
        .then((response) => {
          resolve(response.data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  getSalaryHerdDayReport(employeeId, herdNumber, fromDate) {
    let requestUrl = `${resource}/getSalaryHerdDayReport?assistantNumber=${employeeId}&herdNumber=${herdNumber}&fromDate=${fromDate.toJSON()}`;

    return new Promise(function(resolve, reject) {
      AppUsersClient.get(requestUrl)
        .then((response) => {
          resolve(response.data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  processReportSalaryEmployee(data) {
    let requestUrl = `${resource}/processReportSalaryEmployee`;
    return new Promise(function(resolve, reject) {
      AppUsersClient.put(requestUrl, data)
        .then((response) => {
          resolve(response.data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  lockReportSalaryEmployee(data) {
    let requestUrl = `${resource}/lockReportSalaryEmployee`;
    return new Promise(function(resolve, reject) {
      AppUsersClient.put(requestUrl, data)
        .then((response) => {
          resolve(response.data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  unlockReportSalaryEmployee(data) {
    let requestUrl = `${resource}/unlockReportSalaryEmployee`;
    return new Promise(function(resolve, reject) {
      AppUsersClient.put(requestUrl, data)
        .then((response) => {
          resolve(response.data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  updateReportSalaryEmployee(data) {
    let requestUrl = `${resource}/updateReportSalaryEmployee`;
    return new Promise(function(resolve, reject) {
      AppUsersClient.put(requestUrl, data)
        .then((response) => {
          resolve(response.data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  exportSalaryReportCsv(dto) {
    let requestUrl = `${resource}/exportSalaryReportCsv/?year=${dto.date.getFullYear()}`;
    return new Promise(function(resolve, reject) {
      AppUsersClient.get(requestUrl)
        .then((response) => {
          resolve(response.data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }
};
